import { Box } from "@mui/material";
import { brainTokens } from "../design/brainTheme";

const c = brainTokens.color;

/** SVG progress ring with the percent (or done/total) centred. */
export function ProgressRing({
  pct,
  size = 58,
  stroke = 7,
  label,
}: {
  pct: number;
  size?: number;
  stroke?: number;
  /** Override the centre label (defaults to `${pct}%`). */
  label?: string;
}) {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, pct));
  const off = circ * (1 - clamped / 100);
  const text = label ?? `${Math.round(clamped)}%`;
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      aria-hidden="true"
      sx={{ flex: "none" }}
    >
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={c.border} strokeWidth={stroke} />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={c.teal}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={circ}
        strokeDashoffset={off}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dashoffset .4s ease" }}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        style={{
          fontSize: size * 0.24,
          fontWeight: 700,
          fill: c.ink,
          fontFamily: brainTokens.font.mono,
        }}
      >
        {text}
      </text>
    </Box>
  );
}
